<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate" id="usrsetupcc">
      <div class="row justify-content-center" :class="is_onboard_status && $global.agency_enable_coupon ? 'container__onboarding' : 'centerform'">
        <div :class="containerCreditCard">
          <div class="row">
            <!-- <div class="col-sm-12" v-if="!agencyManualBill">
              <h5 class="info-text">Your Billing Information</h5>
              <h5 v-if="is_onboard_status && !excludeOnBoarding" :style="{ marginBottom: minspend_setting.status ? '0px' : '24px'}">
                You will be charged <strong>${{ is_onboard_price }} today</strong> for your startup fee.
              </h5>
              <h5  style="margin-bottom: 24px;">You are entering into a 12 month contract with a minimum spend requirement of <strong>${{ minspend_setting.first_month }} after 30 days</strong>, <strong>${{ minspend_setting.second_month }} after 60 days</strong> and <strong>${{ minspend_setting.monthly }} each month thereafter</strong>.</h5>
            </div> -->

            <div v-if="$store.getters.userData.user_type != 'client' && !agencyManualBill && (is_onboard_status || minspend_setting.status)" style="padding: 16px; border-left: 4px solid #007BFF; border-radius: 4px; margin-bottom: 8px;">
              <p style="margin: 0; font-size: 14px;">
                <i class="el-icon-info" style="color: #007BFF; margin-right: 4px;"></i>
                <span v-if="is_onboard_status && !excludeOnBoarding">You will be charged 
                  <strong>
                    <span :class="dataCoupon ? 'strikethrough' : ''">
                      {{ formatCurrencyUSD(is_onboard_price) }}
                    </span>
                    <span v-if="dataCoupon" class="discount-price" style="margin-left: 4px;">
                      {{ getTotalDue(is_onboard_price, dataCoupon) }}
                    </span> today
                  </strong>
                  for your startup fee.
                </span>
                You are entering into a 12-month contract with a minimum spend requirement set forth in Addendum C of the Service and Billing Agreement
                <!-- You are entering into a 12-month contract with a minimum spend requirement of <strong v-if="minspend_setting.status">{{ this.formatCurrencyUSD(MINIMUM_SPEND_FLAT) }} </strong>each month. -->
                <!-- <strong v-if="minspend_setting.status">{{ this.formatCurrencyUSD(minspend_setting.first_month) }} after 30 days</strong>, 
                <strong v-if="minspend_setting.status">{{ this.formatCurrencyUSD(minspend_setting.second_month) }} after 60 days</strong>, and 
                <strong v-if="minspend_setting.status">{{ this.formatCurrencyUSD(minspend_setting.monthly) }} each month thereafter</strong>. -->
              </p>
            </div>
            
            <small style="margin-left: 13px; width: 100%;">Card Number</small>
            <div v-if="!agencyManualBill" id="card-element" class="col-sm-12 col-md-12 col-lg-12 card-border">&nbsp;</div> <div class="pt-2 pl-2" v-if="cardfailetoload" style="font-size:0.80143rem"><i class="fas fa-sync-alt pr-2" @click="refreshCCfield();" style="cursor:pointer"></i>Failed to load the Credit Card field. Please <a href="javascript:void(0);" @click="refreshCCfield();" style="font-weight:bold">click here</a> to refresh and try again.</div>
            <div v-if="!agencyManualBill" id="carderror" class="col-sm-12 col-md-12 col-lg-12 pt-2 hide" style="color:red"><small>&nbsp;</small></div>

            <div v-if="!agencyManualBill" class="col-sm-12 col-md-12 col-lg-12 pt-3">
              <ValidationProvider
                name="Card Holder Name"
                rules="required"
                v-slot="{ passed, failed, errors }"
              >
              <base-input
                v-model="cardholdername"
                label="Card Holder Name"
                :error="errors[0]"
                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
            </ValidationProvider>
            </div>

            <div v-if="!agencyManualBill && user.user_type == 'client'" class="col-sm-12 col-md-12 col-lg-12 pb-2">
              <base-radio name="sameCompanyAddr" v-model="radios.billaddresssame" @change="chksameaddresswith" inline>Use company mailing address for the billing address.</base-radio>
              <base-radio name="sameCustAddr" v-model="radios.billaddresssame" @change="chksameaddresswith" inline>Use personal mailing address for the billing address.</base-radio> 
            </div>

            <div v-if="!agencyManualBill" class="col-sm-12 col-md-12 col-lg-12 pt-2">
              <ValidationProvider
                name="billingAddress"
                rules="required"
                v-slot="{ passed, failed, errors }"
              >
              <base-input
                v-model="billingaddress"
                label="Billing Address"
                :error="errors[0]"
                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
            </ValidationProvider>
            </div>
            <div v-if="!agencyManualBill" class="col-sm-12 col-md-12 col-lg-12 mt-2">
                <div class="country-region-select-wrapper">
                  <span  class="country-label">Country *</span>
                  <country-select  class="country-region-select"  v-model="selects.country" :country="selects.country" topCountry="US" />
                  <span v-if="showErrorMessage && !selects.country" style="color: red;">Please select country</span>
                </div> 
            </div>
            <div v-if="!agencyManualBill" class="col-sm-12 col-md-12 col-lg-12 mt-2">
              <div v-if="selects.country" class="country-region-select-wrapper">
              <span class="country-label">{{ selects.country === "CA" ? "Province *" : "State *" }}</span>
              <region-select  class="country-region-select" v-model="selects.state" :country="selects.country" :region="selects.state"  />
              <span v-if="showErrorMessage && !selects.state" style="color: red;">Please select state</span>
              </div>
            </div>
          
            <div v-if="!agencyManualBill" class="col-sm-6 col-md-6 col-lg-6 pt-2">
                <ValidationProvider
                  name="City"
                  rules="required"
                  v-slot="{ passed, failed, errors }"
                
                >
                  <base-input
                    v-model="city"
                    label="City"
                    :error="errors[0]"
                    :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                  </base-input>
                </ValidationProvider>
            </div>
              <!-- <div class="col-sm-4 col-md-4 col-lg-4 pt-2">
                <label>State</label>
                <base-input>
                    <el-select
                      id="stateid"
                      v-model="selects.state"
                      class="select-primary "
                      name="state"
                      inline
                      size="large"
                      filterable
                      default-first-option
                      >
                      <el-option
                        v-for="option in selects.statelist"
                        class="select-primary"
                        :label="option.state"
                        :value="option.state_code"
                        :key="option.state_code"
                      ></el-option>
                    </el-select>
                </base-input>
              </div> -->
              <div v-if="!agencyManualBill" class="col-sm-6 col-md-6 col-lg-6 pt-2">
                <ValidationProvider
                    name="zipcode"
                    rules="required"
                    v-slot="{ passed, failed, errors }"
                  
                  >
                  <base-input
                      v-model="zipcode"
                      label="Zip"
                      :error="errors[0]"
                      :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                    </base-input>
                  </ValidationProvider>
              </div>
            

            <div class="col-sm-12 col-md-12 col-lg-12 mt-2 mb-2">
                    <div class="or-container">
                        <div class="line-separator"></div>
                        <div class="or-label">Service and Billing Agreement</div>
                        <div class="line-separator"></div>
                    </div>
            </div>

            <template v-if="$store.getters.userData.user_type == 'client'">
              <div class="col-sm-12 col-md-12 col-lg-12" v-if="isRenderAgreementClient">
                <!-- SERVICE BILLING AGREEMENT -->
                <iframe ref="iframeRef" src="/service-billing-agreement" width="100%"  height="400vh" @load="onIframeLoad" style="border-radius: 8px;" />
                <!-- SERVICE BILLING AGREEMENT -->
              </div>
            </template>

            <template v-else>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!-- SERVICE BILLING AGREEMENT -->
                <iframe ref="iframeRef" :src="`/service-billing-agreement${isMinimumSpend ? '?version=4' : ''}`" width="100%"  height="400vh" @load="onIframeLoad" style="border-radius: 8px;" />
                <!-- SERVICE BILLING AGREEMENT -->
              </div>
            </template>

            <div class="col-sm-12 col-md-12 col-lg-12 ">
                    <base-checkbox :disabled="agreeTermDisable" v-model="agreeTermBilling" class="pull-left" :class="{'has-danger': agreeTermStatBilling}">I read and Agree with Service and Billing Agreement</base-checkbox>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 " v-if="is_onboard_status || minspend_setting.status">
                <base-checkbox :disabled="agreeTermDisable" v-if="$store.getters.userData.user_type != 'client'" v-model="agreementCharge" :class="{'has-danger': agreementChargeError}">
                  I agree to the 
                  <span v-if="!excludeOnBoarding">
                    <span :class="dataCoupon ? 'strikethrough' : ''">
                      {{ formatCurrencyUSD(is_onboard_price) }}
                    </span>
                    <span v-if="dataCoupon" class="discount-price" style="margin-left: 4px;">
                      {{ getTotalDue(is_onboard_price, dataCoupon) }}
                    </span>
                    setup fee today, and
                  </span> 
                  the 12-month contract including the minimum spend requirement set forth in Addendum C of the Service and Billing Agreement.
                  <!-- the 12-month contract with a minimum spend of {{ this.formatCurrencyUSD(MINIMUM_SPEND_FLAT) }}/month. -->
                  <!-- the 12-month contract with a minimum spend of {{ this.formatCurrencyUSD(minspend_setting.first_month) }} after 30 days, {{ this.formatCurrencyUSD(minspend_setting.second_month) }} after 60 days, and {{ this.formatCurrencyUSD(minspend_setting.monthly) }}/month thereafter. -->
                </base-checkbox>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 " style="padding-top:15px">
              <template v-if="$store.getters.userData.user_type == 'client'">
                <a href="/service-billing-agreement/" target="_blank" style="font-weight:bold;text-decoration:underline">Click here to view service and billing agreement page</a>  
              </template>
              <template v-else>
                <a :href="`/service-billing-agreement${isMinimumSpend ? '?version=4' : ''}`" target="_blank" style="font-weight:bold;text-decoration:underline">Click here to view service and billing agreement page</a>  
              </template>
            </div>
          </div>
        </div>
        <div v-if="is_onboard_status && $store.getters.userData.user_type == 'userdownline' && !excludeOnBoarding && $global.agency_enable_coupon" class="col-sm-12 col-md-12 col-lg-6 col-xl-5">
          <card class="card-billing-summary">
            <div>
              <p style="font-weight: 700; font-size: 18px; margin: 0; text-align: center;">Billing Summary</p>
            </div>
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 16px;">
              <div style="display: flex; align-items: center; width: 100%; gap: 4px;">
                <div style="width: 100%;">
                  <base-input :disabled="isLoadingDataCoupon" v-model="couponCode" @keyup.enter="onApplyCouponCode" @keyup.backspace="onBackspaceCoupon" style="margin-bottom: 0px;" placeholder="Enter coupon code"></base-input>
                </div>
                <base-button type="button" :disabled="isLoadingDataCoupon || dataCoupon" @click="onApplyCouponCode">Apply</base-button>
              </div>
              <div style="border-top: 1px solid #ccc; margin-bottom: 8px; margin-top: 4px;"></div>
              <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                <p style="margin: 0; opacity: 0.8;">Startup fee</p>
                <p style="margin: 0;">
                  {{
                    Number(is_onboard_price).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    })
                  }}
                </p>
              </div>
              <div v-if="dataCoupon" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                <p style="margin: 0; opacity: 0.8;">
                  Discount
                  <span v-if="dataCoupon.type === 'percentage'">({{ dataCoupon.value }}%)</span>
                  <span v-else>
                    ({{ getDiscountAmount(is_onboard_price, dataCoupon).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    }) }})
                  </span>
                </p>
                <p style="margin: 0;">
                  -{{ getDiscountAmount(is_onboard_price, dataCoupon).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
                </p>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                <p style="margin: 0; opacity: 0.8;">Total due</p>
                <p style="margin: 0;">{{ getTotalDue(is_onboard_price, dataCoupon) }}</p>
              </div>
            </div>
          </card>
        </div>
        
        <!--<div class="col-sm-12 col-md-12 col-lg-12 ">
          <base-checkbox :disabled="agreeTermDisable" v-model="agreeTerm" class="pull-left" :class="{'has-danger': agreeTermStat}" >I Agree with <a href="#termofbilling" style="color:#919aa3;text-decoration:underline;font-weight:bold" :style="[agreeTermStat?{'color':'#ec250d'}:'']" v-on:click.stop.prevent="modals.termofbilling = true">Term of Billing</a></base-checkbox>
        </div>-->
      </div>
    </form>
   <!-- MODAL ERROR WARNING-->
    <modal :show.sync="modals.errorbilling" headerClasses="justify-content-center" modalContentClasses="modal-errorbilling">
      <h4 slot="header" class="title title-up">Error</h4>
      <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;"><span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
        </span>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;">Fields marked in red must be filled in completely.</h2>
      <div class="swal2-html-container text-center" id="swal2-html-container" style="display: block;">&nbsp;</div>
      <template slot="footer">
        <div class="container text-center pt-4 pb-4">
          <base-button class="btn btn-secondary" style="min-width:200px" @click="modals.errorbilling = false;">Ok</base-button>
        </div>
      </template>
    </modal>
    <!-- MODAL ERROR WARNING-->

    <!-- MODAL TERM OF BILLING-->
    <modal :show.sync="modals.termofbilling" headerClasses="justify-content-center" id="modaltermofbilling">
              <h4 slot="header" class="title title-up">TERMS of Billing</h4>
              <div class="termofbilling">
                <p>Revised: April 1, 2022</p>
                <ul style="list-style-type:decimal">
                  <li>Acceptance of Terms.
                    <p><strong>By using this Website, you agree to the Terms of Use</strong> (the “Terms”).</p>
                    <p>The use of “we,” “our,” and “us” herein refers to the {{CompanyName}} Marketing, LLC, and “you” and “your” refers to you as the consumer utilizing this Website (“Website”). We maintain this Website to offer Advertising, Marketing and Lead Generation services, among other things.</p>
                    <p>Please read these Terms carefully, as they create a legally binding agreement between you and us regarding your use of the Website. By using the Website, you are agreeing to be legally bound by these Terms. <strong>If you do not agree to follow these Terms, do not use the Website.</strong></p>
                    <p>Your use of this Website is subject to our Privacy Policy, which is hereby incorporated into the Terms by this reference.</p>
                  </li>
                  <li>Using the Website; Authorized Uses.
                    <p>You should only use the Website if you are authorized or it is otherwise legal for you to do so. You agree these Terms and our Privacy Policy govern your use of the Website and the services we offer you through the Website. You also agree to abide by all applicable local, state, federal, and international laws and regulations while using the Website. If you breach these Terms, you are solely responsible for any damages that result therefrom. You are solely responsible for your actions while using the Website and any damages that result. You are responsible for any software, information, data, files, images, documents, text or other material you post, submit or transmit through the Website (“Materials”), including for any damages resulting therefrom.</p>
                  </li>
                  <li>User Submissions.
                    <p>If you post, submit, or transmit Materials on or through the Website, you warrant that:</p>
                      <blockquote>
                        <p>a) The Materials contain truthful, accurate, and complete information and you agree to update information as is necessary to make sure it remains truthful, accurate, and complete;</p>
                        <p>b) You own or control the rights to the Materials and the Materials do not contain copyrighted or protected information;</p>
                        <p>c) You are liable for damages caused by infringement and agree to indemnify us for any third-party damages resulting from such infringement;</p>
                        <p>d) The Materials do not violate the Terms of Use and will not injure another person; and</p>
                        <p>e) Materials posted, submitted, and transmitted are not confidential.</p>
                      </blockquote>
                    
                    <p>You are solely liable for any damages resulting from Materials you post, submit or transmit through the Website. We disclaim all liability for user posts, submissions and transmission on the Website. We do not ratify, subscribe to, or advocate for your views, opinions, recommendations, advice, or theories. We do not preview Materials posted, submitted, or transmitted through the Website. We may monitor, edit, or remove Materials and/or terminate your access to the Website or any part of the Website based on the Materials you post, submit or transmit.</p>
                    <p>By posting, submitting, or transmitting Materials on or through the Website, you grant us an  irrevocable, perpetual, non-exclusive, royalty free, worldwide license to use, sublicense, reproduce, adapt, modify, translate, publish, distribute, perform, or publicly display all or any portion of the Materials, subject to our Privacy Policy, without attributing the Materials to you. You agree that we are not bound by any confidentiality requirements for these Materials.</p>
                    <p>We may use the Materials you post, submit, or transmit and any techniques, ideas, or concepts found therein, in any way and for any purpose. We may transmit or distribute the Materials on public networks or other media, and make such Materials available to other companies, organizations, or individuals. We may make changes to Materials as necessary to conform or adapt Materials to technical requirements of public networks or media.</p>
                  </li>
                  <li>Intellectual Property Rights.
                    <p>This Website contains our intellectual property. In some instances, the Website may contain the intellectual property of third parties. All intellectual property is protected by U.S. and international copyright law and other intellectual property laws. You may not reproduce or distribute the Website content in any way without our express written consent. Doing so may result in civil and criminal penalties, and you will be prosecuted to the maximum extent possible under law. The publication or dissemination of any link to the contents of this Website, other than a link to <a href="https://exactmatchmarketing.com" target="_blank">https://exactmatchmarketing.com</a>, without our express written consent is prohibited.</p>
                    <p>We grant you a personal, non-transferable, non-exclusive, limited, and freely revocable license to view, download, or print content available on the Website. However, we may limit your ability to access, view, download, or print content at our sole discretion, or completely revoke this license with reasonable notice to you. The content you access, view, download, or print may be subject to other licenses and you agree to abide by those licenses.</p>
                    <p>Nothing stated herein shall be construed to confer any rights to our (or any third party’s rights to) intellectual property, whether by estoppel, implication, waiver, or otherwise, except where expressly stated. You agree not to change, remove, or deface any of the copyright notices, trademarks, service marks, or other intellectual property made available by us in connection with this Website, including if you download or print content from the Website. You agree not to use any of the trademarks, service marks, or other content accessible through the Website for any purpose not intended by us. You agree not to use any of the trademarks, service marks, or other content accessible through the Website in any manner that is likely to confuse others about who owns such trademarks, service marks, or other content. You agree not to defame or disparage us, our trademarks or service marks, or any aspect of this Website. Unless otherwise stated, you agree not to copy, adapt, change, translate, decompile, disassemble, reverse engineer, or create derivative works of this Website, any software or other features used in connection with or made available through your use of this Website.</p>
                  </li>
                  <li>Copyright Infringement Notification.
                    <p>If you believe that any part of our Website or any content thereon infringes on another’s copyright, please notify us, in writing, with the following information: </p>
                         <blockquote>
                           <p>1) Identification of the copyrighted work claimed to have been infringed, or identification of a representative list of such works if multiple copyrighted works are involved;</p>
                           <p>2) Description of the location of an original or an authorized copy of the copyrighted work (i.e., a URL);</p>
                           <p>3) Description of the location of the allegedly infringing material on our Website (i.e., a URL);</p>
                           <p>4) Your contact information, including your address, telephone number, and an electronic mail address, if available;</p>
                           <p>5) A statement by you that you believe, in good faith, that the use of the material at issue is not authorized by the copyright owner, its agent, or the law;</p>
                           <p>6) A statement by you, under penalty of perjury, that the information you are providing is accurate and that you are either the copyright owner or that you are authorized to act for the copyright owner; and</p>
                           <p>7) The signature (physical or electronic) of the copyright owner or the person authorized to act for the copyright owner.</p>
                         </blockquote>
                   
                    <p>Please send your written communication to:</p>
                    <p>{{CompanyName}} Marketing, LLC</p>
                    <p>copyright(at)exactmatchmarketing.com</p>
                    <p>If you knowingly and materially misrepresent that our Website content or activity infringes upon another’s copyright, you may be liable for damages, including for costs and attorneys’ fees incurred by the accused infringer, the copyright owner or their agent, or a service provider or other person who is damaged therefrom, due to reliance on the misrepresentation, the removal or disablement of the allegedly infringing material, or the replacement of the allegedly infringing material, pursuant to 17 U.S.C. § 512(f).</p>
                    <p>This information is provided as a courtesy and should not be considered legal advice.</p>
                  </li>
                </ul>
              </div>
              <template slot="footer">
                <div class="container text-center pb-4">
                  <base-button @click="agreedtermofbilling();">Yes, I Understand</base-button>
                </div>
              </template>
            </modal>
      <!-- MODAL TERM OF BILLING -->
  </ValidationObserver>
</template>
<script>
import { Select, Option, Message } from 'element-ui';
import { Modal,BaseCheckbox,BaseRadio } from '/src/components';
import BaseInput from '../../../../../../components/Inputs/BaseInput.vue';
import Vue from 'vue';
import Global from '../../../../../../plugins/global';
import { DOCUMENTS, MINIMUM_SPEND } from '../../../../../../shared/constants'
import { decryptData, encryptData } from '../../../../../../helpers/crypto'
import { mapActions } from "vuex";

Vue.use(Global);
var _elements;
var _cardElement;
var _stripe;
var _CardValidate;
var _tokenid = '';
var _sppubkey = '';
var _this;

export default {
  props: {
    isMinimumSpend: Boolean,
    isRenderAgreementClient: Boolean,
    excludeOnBoarding: Boolean,
  },
  components: {
    Modal,
    BaseCheckbox,
    [Option.name]: Option,
    [Select.name]: Select,
    BaseRadio,
  },
  data() {
    BaseInput
    return {
      agencyManualBill:false,
      showErrorMessage:false,
      cardfailetoload:false,
      CompanyName: 'Exact Match Marketing',
      CompanyAddress: '',
      CompanyPrivacyPolicy: '',
      CompanyTermsofuse: '',
      CompanyWeb: '',
      CompanyEmail: '',
      CustomerCareEmail: '',
      CustomerCareName: '',
      CustomerCompanyName: '',
      CustomerCompanyEmail: '',
      CustomerEmail: '',
      CustomerName: '',
      CustomerAddress: '',
      user: '',

      cardholdername: '',
      billingaddress: '',
      city: '',
      zipcode: '',
      selects: {
        state: '',
        country: '',
        statelist: [],
      },
      ccmonth:'',
      ccyear:'',
      radios: {
        billaddresssame:'',
      },
      modals: {
        termofbilling:false,
        errorbilling:false,
      },
      agreeTermDisable:true,
      agreeTermBilling:false,
      agreeTermStatBilling:false,
      agreeTerm:false,
      agreeTermStat:false,

      platform: false,
      platformagency: false,
      emmplatform:false,
      is_onboard_status:false,
      is_onboard_price:0,
      minspend_setting:{
        status:false,
        first_month:0,
        second_month:0,
        monthly:0
      },
      intervalId: null,
      agreementCharge: false,
      agreementChargeError: false,
      couponCode: '',
      dataCoupon: null,
      isLoadingDataCoupon: false,
    };
  },
  methods: {
    ...mapActions(['userLogSaved', 'userServiceAgreementConfirm']),
    refreshCCfield() {
      if (this.$global.sppubkey != "") {
        _sppubkey = this.$global.sppubkey;
        this.initstripelib();
        //this.cardfailetoload = false;
      }else{
        this.$store.dispatch('getGeneralSetting', {
              companyID: this.user.company_root_id,
              settingname: 'rootstripe',
          }).then(response => {
            _sppubkey = response.data;
            this.initstripelib();
            //this.cardfailetoload = false;
          },error => {
            this.$notify({
              type: 'primary',
              message: 'Please try to refresh the page',
              icon: 'fas fa-bug'
            })
            this.cardfailetoload = true;    

          });
      }
    },
    agreedtermofbilling() {
      this.agreeTerm = true;
      this.agreeTermDisable = false;
      this.modals.termofbilling = false;
    },
    termscrolltop() {
      this.$refs.termsandcond.scrollTop = 0;
    },
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      //console.log(Math.ceil(scrollTop) + ' | ' + clientHeight + ' | ' + scrollHeight);
      if (Math.ceil(scrollTop) + (clientHeight + 20) >= scrollHeight) {
        this.agreeTermDisable = false;
      }
    },
    onIframeLoad(){
      let iframe = this.$refs.iframeRef;
      try {
        let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        if(iframeDoc){
          const style = iframeDoc.createElement('style');
          style.innerHTML = '.full-page > .content { padding-top: 0 !important; padding-bottom: 40px !important; }';
          iframeDoc.head.appendChild(style);
        }

        iframeDoc.addEventListener("scroll", () => {
          let scrollHeight = iframeDoc.documentElement.scrollHeight;
          let scrollTop = iframeDoc.documentElement.scrollTop;
          let clientHeight = iframeDoc.documentElement.clientHeight;

          if (scrollTop + clientHeight >= scrollHeight - 10) {
            this.agreeTermDisable = false;
          }
        });
      } catch (error) {
        console.warn("cross-origin restriction.");
      }
    },
    initstripelib() {
      var chkload = this.$global.stripescriptload;
      if (chkload === false) {
        this.$global.initStripeScriptLoad(true);
        $.getScript( "https://js.stripe.com/v3/" )
        .done(function( script, textStatus ) {
            initcreditcard();
        })
        .fail(function( jqxhr, settings, exception ) {
            //$( "div.log" ).text( "Triggered ajaxError handler." );
        });
      }else{
        initcreditcard();
      }
      
    },
    chksameaddresswith() {
      
      if (this.radios.billaddresssame == "sameCompanyAddr") {
        this.billingaddress = this.$store.getters.userData.company_address
        this.city = this.$store.getters.userData.company_city
        this.selects.state = this.$store.getters.userData.company_state_code
        this.selects.country = this.$store.getters.userData.company_country_code
        this.zipcode = this.$store.getters.userData.company_zip
      }else{
        this.billingaddress = this.$store.getters.userData.address
        this.city = this.$store.getters.userData.city
        this.selects.state = this.$store.getters.userData.state_code
        this.selects.country = this.$store.getters.userData.country_code
        this.zipcode = this.$store.getters.userData.zip
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    makeFinishSetup() {
      var user = this.$store.getters.userData
      this.$store.dispatch('userSetupComplete', {
          usrID: user.id,
          statuscomplete: 'T',
      }).then(response => {
          //console.log(response.params)
          /*this.$store.dispatch('setUserData', {
              user: response.params,
          });*/
          this.$store.dispatch('retrieveUserData',{
                usrID: user.id,
          });
          this.$global.creditcardsetup = true;
      },error => {
          
      });
    },
    fetchUserData(){
      const userData = this.$store.getters.userData;

      this.$store.dispatch('retrieveUserData',{
        usrID: userData.id,
      });
    },
    ccsetupfinish() {
      var user = this.$store.getters.userData
      this.$store.dispatch('retrieveUserData',{
                usrID: user.id,
      });
    },
    showErrorModal() {
      this.modals.errorbilling = true;
    },
    async agreementDataWallet() {
      const userData = this.$store.getters.userData
      if (
        ['userdownline', 'user'].includes(userData.user_type) && // jika agency
        this.$global.idsys == this.$global.masteridsys && // jika di bawah root emm saja
        this.$global.betaFeature.data_wallet.is_beta && (this.$global.betaFeature.data_wallet.apply_to_all_agency || this.$global.isBeta) // jika data wallet masih beta dan (apply to all atau user ini beta)
      ) {
        const feature_id = this.$global.betaFeature.data_wallet.id;
        const feature_name = this.$global.betaFeature.data_wallet.name;
        const payload = {
          feature_id: feature_id,
          feature_name: feature_name,
          user_id: userData.id,
          is_marketing_services_agreement_feature: 'T',
          company_name: userData.company_name,
          company_id: userData.company_id,
          location_menu: this.$route.name,
        };
        await this.$store.dispatch('marketingServicesAgreementFeature', payload);
      }
    },
    createStripeCustomer() {
      var _store = this.$store;
      var _this = this;
      var _user = this.$store.getters.userData

      return new Promise((resolve, reject) => {
        _stripe.createToken(_cardElement).then(function(result) {
            if(result.error) {
                $('.btnNext0').html('Next');
                $('.btnNext0').attr('disabled',false);
                $('.btnNext1').html('Next');
                $('.btnNext1').attr('disabled',false);
                console.log(result.error.message);
                $('#carderror').html('<small style="color:red"><sup>*</sup>' + result.error.message + '</small>');
                $('#carderror').show();
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
                _this.showErrorModal();
            }else{
                $('#carderror').hide();
                _tokenid = result.token.id;
                _store.dispatch('paymentcustomersetup', {
                    tokenid: _tokenid,
                    cardholder: _this.cardholdername,
                    address: _this.billingaddress,
                    city: _this.city,
                    state: _this.selects.state,
                    country: _this.selects.country,
                    zip: _this.zipcode,
                    usrID: _user.id,
                    action: '',
                    document_type: _this.checkDocumentUrl(),
                    code: _this.dataCoupon ? _this.couponCode : '',
                }).then(async (response) => {
                    //console.log(response.result)
                    if(response.result == 'success') {
                      //_this.makeFinishSetup();
                      if (_user.user_type == 'client') {
                        $('.btnNext2').html('Go To Dashboard');
                      }else{
                        // _this.ccsetupfinish();
                        $('.btnNext2').html('Go To General Settings');
                        _this.onLogsContractAgreement();
                        await _this.saveCCInformation();
                        await _this.agreementDataWallet(); // khusus agency emm aja
                      }

                      $('.btnNext0').html('Next');
                      $('.btnNext0').attr('disabled',false);
                      $('.btnNext1').html('Next');
                      $('.btnNext1').attr('disabled',false);

                      $('html, body').animate({
                          scrollTop: 0
                      }, 500);
                      
                      //if(_user.user_type == 'client'){
                        _this.makeFinishSetup();
                      //}
                      
                      resolve(true);   
                    } else {
                      $('.btnNext0').html('Next');
                      $('.btnNext0').attr('disabled',false);
                      $('.btnNext1').html('Next');
                      $('.btnNext1').attr('disabled',false);

                      Vue.prototype.$notify({
                        type: 'danger',
                        message: 'Payment registration failed. Please check your details or contact the admin for further assistance.',
                        icon: 'fas fa-bug'
                      })
                    }
                },error => {
                    $('.btnNext0').html('Next');
                    $('.btnNext0').attr('disabled',false);
                    $('.btnNext1').html('Next');
                    $('.btnNext1').attr('disabled',false);
                    $('#carderror').html('<small style="color:red"><sup>*</sup>The credit card has expired, reached its limit, or is not being authorized as a valid credit card</small>');
                    $('#carderror').show();
                    $('html, body').animate({
                        scrollTop: 0
                    }, 500);
                     _this.showErrorModal();
                });
            }
        });
      });
      /*token = _stripe.createToken(_cardElement).then(function(result) {
            if(result.error) {
                console.log(result.error.message);
            }else{
              _tokenid = result.token.id;
              //console.log('Token : ' + _tokenid);
                _store.dispatch('paymentcustomersetup', {
                    tokenid: _tokenid,
                }).then(response => {
                    //console.log(response.result)
                    if(response.result == 'success') {
                      //_this.makeFinishSetup();
                     
                      
                    }
                },error => {
                    
                });

            }
      });*/
    },
    getStateList() {
      this.$store.dispatch('getStateList').then(response => {
          this.selects.statelist = response.params
      },error => {
          
      });
    },
    validate() {
      const userData = this.$store.getters.userData;

      if (this.user.user_type != 'client' || (this.user.manual_bill == 'F' && this.user.user_type == 'client')) {
        if (typeof(_cardElement) == "undefined" || _sppubkey == "") {
          this.cardfailetoload = true;
          return false;
        }

        if (this.selects.country == '') {
                this.$notify({
                  type: 'primary',
                  message: 'Please select country',
                  icon: 'fas fa-bug'
                })
                this.showErrorMessage = true;
              }
        if (this.selects.state == '') {
          this.$notify({
            type: 'primary',
            message: 'Please select state',
            icon: 'fas fa-bug'
          })
          this.showErrorMessage = true;
          // $('#usrsetupcc #stateid').siblings().find('.el-select__caret.el-input__icon').addClass('has-danger');
          // $('#usrsetupcc #stateid').siblings().find('.el-select__caret.el-input__icon').removeClass('has-success');
        }else{
          $('#usrsetupcc #stateid').siblings().find('.el-select__caret.el-input__icon').removeClass('has-danger');
          $('#usrsetupcc #stateid').siblings().find('.el-select__caret.el-input__icon').addClass('has-success');
        }

        /*this.agreeTermStat = false;
        if (this.agreeTerm == false) {
            this.agreeTermStat = true;
        }*/
        this.agreeTermStatBilling = false;
        if (this.agreeTermBilling == false) {
          this.agreeTermStatBilling = true;
        }

        return this.$refs.form.validate().then(res => {
          if(res) {
            this.agreeTermStatBilling = false;
            if (this.agreeTermBilling == false) {
              this.agreeTermStatBilling = true;
              $('html, body').animate({
                  scrollTop: 0
              }, 500);
              this.modals.errorbilling = true;
              return false;
            }
            
            /*this.agreeTermStat = false;
            if (this.agreeTerm == false) {
              this.agreeTermStat = true;
              return false;
            }*/
            if (this.selects.state !== '' && this.selects.country != '' && (typeof(_cardElement) != "undefined" && _sppubkey != "")) {

              const isNotClient = this.user.user_type != 'client';
              if(isNotClient && !this.agreementCharge && (this.is_onboard_status || this.minspend_setting.status)){
                this.agreementChargeError = true;

                this.$notify({
                  type: 'danger',
                  message: 'You must agree to the Startup Fee & Contract Agreement before continuing',
                  icon: 'fas fa-bug'
                })
                return;
              }
              //this.createStripeCustomer();
              $('.btnNext0').html('Processing...')
              $('.btnNext0').attr('disabled',true);
              $('.btnNext1').html('Processing...')
              $('.btnNext1').attr('disabled',true);
              this.$emit("on-validated", res,this.$data);
              return this.createStripeCustomer();
            }else{
              this.showErrorMessage = true;
            }
            
            /*this.makeFinishSetup();
            this.$emit("on-validated", res,this.$data);
            return res;
            */
          }else{
            //this.showpoperror();
            $('html, body').animate({
              scrollTop: 0
            }, 500);
            this.modals.errorbilling = true;
          }
        });
      }else{
            this.agreeTermStatBilling = false;
            if (this.agreeTermBilling == false) {
              this.agreeTermStatBilling = true;
            }
            
            if (this.agreeTermBilling) {

              const payload_agreement = {
                    userID: userData.id,
                    document_type: this.checkDocumentUrl(),
              }

              this.userServiceAgreementConfirm({ data: payload_agreement });

              $('.btnNext0').html('Processing...')
              $('.btnNext0').attr('disabled',true);
              $('.btnNext1').html('Processing...')
              $('.btnNext1').attr('disabled',true);
              return new Promise((resolve, reject) => {
                  this.$store.dispatch('paymentdirectcustomersetup', { 
                        usrID: this.user.id,
                  }).then(response => {
                        //console.log(response.result)
                        if(response.result == 'success') {
                          this.ccsetupfinish();
                          if (this.user.user_type == 'client') {
                            $('.btnNext2').html('Go To Dashboard');
                          }
                          $('.btnNext0').html('Next')
                          $('.btnNext0').attr('disabled',false);
                          $('.btnNext1').html('Next')
                          $('.btnNext1').attr('disabled',false);
                        
                          $('html, body').animate({
                              scrollTop: 0
                          }, 500);
                          
                          resolve(true);
                        }
                    },error => {
                        
                    });
              });
            }
      }

    },
    checkDocumentUrl(){
      const userData = this.$store.getters.userData;
      if(this.isMinimumSpend){
        // return DOCUMENTS.MINIMUM_SPEND_V2;
        // return DOCUMENTS.MINIMUM_SPEND_V3;
        return DOCUMENTS.MINIMUM_SPEND_V4
      } else if (userData.user_type != 'client'){
        return DOCUMENTS.DEFAULT_AGENCY;
      } else if (userData.user_type == 'client'){
        return DOCUMENTS.DEFAULT_CLIENT;
      } else {
        return ''
      }
    },
    async onLogsContractAgreement(){
        const userData = this.$store.getters.userData;
        const document = await this.$store.dispatch('getDocumentAgreementFile', {
            // name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V2 : DOCUMENTS.DEFAULT_AGENCY,
            // name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V3 : DOCUMENTS.DEFAULT_AGENCY,
            name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V4 : DOCUMENTS.DEFAULT_AGENCY,
        })

        const discount = this.getDiscountAmount(this.is_onboard_price, this.dataCoupon).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        const total = this.getTotalDue(this.is_onboard_price, this.dataCoupon);
        const onBoardPrice = this.formatCurrencyUSD(this.is_onboard_price);
        const minSpendFirstMonth = this.formatCurrencyUSD(this.minspend_setting.first_month);
        const minSpendSecondMonth = this.formatCurrencyUSD(this.minspend_setting.second_month);
        const minSpendMonthly = this.formatCurrencyUSD(this.minspend_setting.monthly);

        let desc = `The user has agreed ${onBoardPrice} ${this.dataCoupon ? `discount: ${discount} | total: ${total}` : ''} setup fee today, and 12-month contract with a minimum spend of ${MINIMUM_SPEND.FLAT}/month.`
        // let desc = `The user has agreed ${onBoardPrice} ${this.dataCoupon ? `discount: ${discount} | total: ${total}` : ''} setup fee today, and 12-month contract with a minimum spend of ${minSpendFirstMonth} after 30 days, ${minSpendSecondMonth} after 60 days, and ${minSpendMonthly}/month thereafter.`
        desc += `| Menu: Payment Setup | fileUrl: ${document.url}`;

        const payload = {
            userID: userData.id,
            action: "Service and Billing Agreement - Startup Fee & Minimum Spend",
            desc,
            userIP: this.$store.getters.userData.ip_login,
            target_userID: userData.id,
        }
        const userViewMode = userData.isViewMode ? userData.isViewMode : false;
        if(userViewMode){
            const userRoot = await decryptData(localStorage.getItem('userDataOri'))
            payload.userID = userRoot.id;
        }

        await this.userLogSaved({ data: payload });
    },
    async saveCCInformation(){
      const payload = {
        address: this.billingaddress,
        city: this.city,
        state: this.selects.state,
        country: this.selects.country,
        zip: this.zipcode,
      }

      const data = await encryptData(payload);
      localStorage.setItem('info-cc', data);
      this.$emit('cc-info-saved', payload);
    },
    onApplyCouponCode(){
      if (!this.couponCode || this.couponCode.trim() === '') {
        return;
      }

      this.isLoadingDataCoupon = true;
      const payload = {
        code: this.couponCode,
      }

      this.$store.dispatch('couponCode', payload)
        .then(response => {
          this.dataCoupon = response.data;
          this.isLoadingDataCoupon = false;
          Message.success('Coupon applied successfully!')
        }).catch(error => {
          this.isLoadingDataCoupon = false;
          Message.error(error.message)
        })
    },
    onBackspaceCoupon() {
      this.dataCoupon = null;
    },
    getDiscountAmount(price, coupon) {
      const priceNum = Number(price);

      if (!coupon || !coupon.type || !coupon.value) return 0;

      if (coupon.type === 'percentage') {
        return priceNum * (Number(coupon.value) / 100);
      }

      if (coupon.type === 'fixed') {
        return Math.min(Number(coupon.value), priceNum);
      }

      return 0;
    },
    getTotalDue(price, coupon) {
      const discount = this.getDiscountAmount(price, coupon);
      const total = Number(price) - discount;
      return total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },
    formatCurrencyUSD(price){
      return Number(price).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }
  },
  computed: {
    containerCreditCard(){
      if(this.is_onboard_status && this.$global.agency_enable_coupon){
        return 'col-sm-12 col-md-12 col-lg-6 col-xl-7'
      } else {
        return 'col-sm-12 col-md-12 col-lg-12'
      }
    },
    MINIMUM_SPEND_FLAT(){
      return MINIMUM_SPEND.FLAT
    }
  },
  watch: {
    agreeTermBilling: function(value) {
      if (value == true) {
        this.agreeTermStatBilling = false;
      }
    },
    agreementCharge: function(value) {
      if (value == true) {
        this.agreementChargeError = false;
      }
    },
    couponCode: {
      handler(newValue, oldValue){
        if(newValue){
          this.dataCoupon = null;
        }
      },
    },
    /*agreeTerm: function(value) {
      if (value == true) {
        this.agreeTermStat = false;
      }
    },*/
    isRenderAgreementClient: {
      handler(newValue, oldValue){
        // dont remove this function
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    
    this.minspend_setting = this.$global.rootminspendsetting ? this.$global.rootminspendsetting : this.minspend_setting;    
    this.is_onboard_status = this.$global.agency_onboarding_status;
    this.is_onboard_price = this.$global.agency_onboarding_price;
    this.user = this.$store.getters.userData
    if (this.user.manual_bill == 'T' && this.user.user_type == 'client') {
      this.agencyManualBill = true;
    }else{
      this.agencyManualBill = false;
    }
    //console.log(user);
    if (this.user.user_type == 'userdownline') {
       this.CompanyName = this.user.company_name;
       this.CompanyAddress = this.user.company_address + ', ' +  this.user.company_city + ', ' +  this.user.company_state_name + ' ' +  this.user.company_zip;
       this.CompanyEmail = this.user.company_email;
       this.CustomerName = this.user.name;
       this.CustomerEmail = this.user.email;
    }else{
      this.CompanyName = this.user.companyparentname;
      this.CompanyAddress = this.user.companyparentaddress + ', ' +  this.user.companyparentcity + ', ' +  this.user.companyparentstate + ' ' +  this.user.companyparentzip;
      this.CompanyEmail = this.user.companyparentemail;
      this.CustomerCareEmail = this.user.customercare;
      this.CustomerCareName = this.user.customercarename;
      this.CustomerCompanyName = this.user.company_name;
      this.CustomerCompanyEmail = this.user.company_email;
      this.CustomerName = this.user.name;
      this.CustomerAddress = this.user.address + ', ' +  this.user.city + ', ' +  this.user.state_name + ' ' +  this.user.zip;
    }

    this.CompanyWeb = document.location.hostname;
    this.CompanyPrivacyPolicy = 'https://' + this.CompanyWeb + '/privacy-policy';
    this.CompanyTermsofuse = 'https://' + this.CompanyWeb + '/term-of-use';
   
    if (typeof(this.user.user_type) == 'undefined' || this.user.user_type == 'client') {
       this.platformagency = true;
    }else{
      if(this.user.user_type == 'userdownline' && this.$global.agencyplatformroot == true) {
        this.emmplatform = true;
      }else{
        this.platform = true;
      }
    }

    _sppubkey = this.$global.sppubkey;
    _this = this;
    this.agreeTermDisable = true;
    this.cardfailetoload = false;
    if (typeof(_sppubkey) == "undefined" || _sppubkey == "") {
      this.cardfailetoload = true;
    }else{
      this.initstripelib();
    }
    // this.getStateList();
    
  }
};

function initcreditcard() {
  if (!$('#card-element').length) return;

  const activeTheme = localStorage.getItem('user-theme') || 'light-theme';

  const getStyle = (theme) => {
    const isLight = theme === 'light-theme';
    return {
      base: {
        color: isLight ? '#101111' : '#ffffff',
        fontSize: '16px',
        fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: isLight ? '#8a8a8a' : '#cccccc',
        },
        iconColor: isLight ? '#101111' : '#ffffff',
      },
      invalid: {
        color: '#e5424d',
        iconColor: '#e5424d',
        ':focus': {
          color: isLight ? '#101111' : '#ffffff',
        },
      },
    };
  };

  const style = getStyle(activeTheme);

  _stripe = Stripe(_sppubkey);
  _elements = _stripe.elements();
  _cardElement = _elements.create('card', {
    hidePostalCode: true,
    style,
  });

  _cardElement.mount('#card-element');

  _cardElement.on('change', (event) => {
    if (event.error) {
      $('#carderror')
        .html(`<small style="color:red"><sup>*</sup>${event.error.message}</small>`)
        .show();
    } else {
      $('#carderror').hide();
    }
  });

  window.addEventListener('theme-changed', (event) => {
    const newTheme = event.detail || localStorage.getItem('user-theme');
    const newStyle = getStyle(newTheme);

    if (_cardElement) {
      try {
        _cardElement.update({ style: newStyle });
      } catch (err) {
         console.warn('⚠️ Update failed, remounting Stripe element', err);
        _cardElement.unmount();
        _cardElement = _elements.create('card', { hidePostalCode: true, style: newStyle });
        _cardElement.mount('#card-element');
      }
    }
  });
}

</script>
<style>
.modal-errorbilling {
  max-width: 520px;
  margin: 0 auto;
}
#modaltermofbilling .termofbilling {
  overflow-y: scroll;
  height: 300px;
  width: 100%;
  /*border: 1px solid #525f7f;*/
  padding: 10px;
}

  .centerform {
    width: 90%;
    margin: 0 auto;
  }

@media (min-width: 1024px) {
  .centerform {
    width: 50%;
    margin: 0 auto;
  }
}
.ccmonth {
  width: 50% !important;
}
.ccyear {
  width: 50% !important;
  padding-left: 10px;
}
#usrsetupcc .card-border {
  max-width: 95.5% !important;
  line-height: 1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #525f7f;
  border-radius:6px;
  padding: 8px 12px 6px 12px;
  margin:8px 0px 4px -1px;
  height:39px;
  box-sizing: border-box;
  transform: translateZ(0);
  -webkit-user-select:text;
  margin-left: 15px;
}

.termsx {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 300px;
  width: 100%;
  border: 1px solid #525f7f;
  padding: 10px;
  background-color: #FFF;
}

.termsx p, .termsx span {
  color: #525f7f !important;
}

.termsx a,.termsx a:hover {
  color: #942434 !important;
}

#style-2::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	/*border-radius: 10px;*/
	background-color: gray;
  opacity: 0.5;
}

#style-2::-webkit-scrollbar
{
	width: 12px;
	background-color: #525f7f;
}

#style-2::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #525f7f;
}

.container__onboarding {
  max-width: 99%;
  margin: 0 auto;
}

.card-billing-summary .card-body {
  margin-top: 0px;
}

.card-wizard .disabled {
    display: block;
}

.termsx p.bold {
    font-weight: bold;
}

.strikethrough {
  text-decoration: line-through;
  color: #999;
}

.discount-price {
  color: green;
  font-weight: bold;
}

@media (max-width: 992px) {
  .card-billing-summary {
    margin-top: 24px;
  }
}

</style>
